import ForgeLogo from "../components/logo";

/**
 * The mark beside the brand name in the admin chrome.
 *
 * The Forge logo is Forge's — it belongs to the nonprofit and has no
 * business sitting above "Makua Retreats". Any other product gets a plain
 * monogram in the brand's own accent colour until it has a mark of its
 * own, at which point this is the one place to add it.
 */
export default function BrandMark({ product, short, fill, width = 38, height = 38 }) {
  if (product === "forge") return <ForgeLogo fill={fill} width={width} height={height} />;

  const letter = String(short || "?").trim().charAt(0).toUpperCase();

  return (
    <svg
      viewBox="0 0 40 40"
      width={width}
      height={height}
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <circle cx="20" cy="20" r="18.5" fill="none" stroke={fill} strokeWidth="2.5" />
      <text
        x="20"
        y="20"
        textAnchor="middle"
        dominantBaseline="central"
        fill={fill}
        fontSize="18"
        fontWeight="700"
        fontFamily="Inter, system-ui, sans-serif"
      >
        {letter}
      </text>
    </svg>
  );
}

/**
 * The same mark shaped for CircularBadge, which calls its `icon` as
 * `<Icon color size />`. Returns null for Forge so the badge keeps its own
 * default logo.
 *
 * Build this with useMemo — a component identity created fresh on every
 * render would remount the badge each time.
 */
export const makeBadgeIcon = (product, short) =>
  product === "forge"
    ? null
    : function BrandBadgeIcon({ color, size }) {
        return <BrandMark product={product} short={short} fill={color} width={size} height={size} />;
      };
